import { useCallback, useMemo } from 'react';

import { useWindowSize } from 'react-use';

import { theme } from '../theme';

export const useBreakpoints = () => {
	const { width } = useWindowSize();

	const breakpoints = useMemo(
		() =>
			Object.values(theme.breakpoints as Record<string, `${string}px`>).map(
				(breakpointPx) => +breakpointPx.replace('px', ''),
			),
		[],
	);

	const smallerThanNthBreakpoint = useCallback(
		(nThBreakpoint: number) => width < breakpoints[nThBreakpoint],
		[breakpoints, width],
	);

	return { smallerThanNthBreakpoint, breakpoints };
};
